import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

export enum ProjectType {
  ongoing,
  underPreparation,
  closed,
}

@Component({
  selector: 'app-profile-projects-tab',
  imports: [CommonModule, TranslateModule],
  templateUrl: './projects-tab.component.html',
  styleUrl: './projects-tab.component.scss',
})
export class ProfileProjectsTabComponent {
  constructor(private router: Router) {}

  protected goToProjectIdea(): void {
    this.router.navigateByUrl('/new-project-idea');
  }
}
